import { Col, Container, Row } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import CustomSetOffTable from "../../../components/CustomSetOffTable";
import { React, useCallback, useEffect, useMemo, useState } from "react";
import * as axiosInstance from "../../../services/axiosInstance";
import Helper from "../../../utils/Helper";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../selectors/auth";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import { useHistory } from "react-router";
import ConfirmationSetOffModal from "./modal/ConfirmationSetOffModal";
import PAGE from "../../../utils/Destination";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import * as setOffSelectors from "../../../selectors/set-off";
import * as userSelectors from "../../../selectors/user";
import NotificationMessage from "../../../utils/NotificationMessage";
import SetoffDisclaimerNote from "../DisclaimerNote";
function SetOff() {
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [partAmt, setPartAmt] = useState(null);
  const [type, setType] = useState("");
  const selectedCurrency = useSelector(state=>userSelectors.getUserAccountCurrencySelectedObject(state.user))


  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const history = useHistory();
  const search = history?.location?.search;
  const { loading, data } = useQuery({
    queryKey: ["set-off-data"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/setoff${search}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });

  const setOffData = _.get(data, ["data"], []);

  const handleSubmit = useCallback(async(postData)=>{
      setIsLoading(true);
      try {
          const response = await axiosInstance.post("clientarea/setoff", { items: postData });
          if (response.code === 200) {
              history.push(PAGE.SET_OFF_HISTORY);
          }
      } catch (e) {
          console.log("ee" + e);
      } finally {
          setIsLoading(false);
      }
  },[])

  const onClickAutoSetUp = ()=> {

   if (debitValue == 0 && creditValue == 0) {

     const trustTotal = _.sumBy(setOffData, function(i) {
       return setOffSelectors.getSetOffTotalOutstandingBalance(i) < 0 ? setOffSelectors.getSetOffTotalOutstandingBalance(i) : 0;
     });
     const outstandingTotal = _.sumBy(setOffData, function(i) {
       return setOffSelectors.getSetOffTotalOutstandingBalance(i) > 0 ? setOffSelectors.getSetOffTotalOutstandingBalance(i) : 0;
     });
     let availableOffsetAmount = _.min([Math.abs(trustTotal), Math.abs(outstandingTotal)]);
     let availableWithdrawAmount = availableOffsetAmount * -1;
     let autoOffsetData = _.flatMap(setOffData, function(item, key) {
       if (
         availableOffsetAmount > 0 &&
         setOffSelectors.getSetOffTotalOutstandingBalance(item) > 0 &&
         availableOffsetAmount >= setOffSelectors.getSetOffTotalOutstandingBalance(item)
       ) {
         availableOffsetAmount -= setOffSelectors.getSetOffTotalOutstandingBalance(item);
         return {
           negative: false,
           total: setOffSelectors.getSetOffTotalOutstandingBalance(item),
         };
       } else if (
         availableOffsetAmount > 0 &&
         setOffSelectors.getSetOffTotalOutstandingBalance(item) > 0 &&
         availableOffsetAmount < setOffSelectors.getSetOffTotalOutstandingBalance(item)
       ) {
         const remainingAmount = availableOffsetAmount;
         availableOffsetAmount -= remainingAmount;
         return {
           negative: false,
           total: Math.abs(remainingAmount).toFixed(2),
         };
       } else if (
         availableWithdrawAmount < 0 &&
         setOffSelectors.getSetOffTotalOutstandingBalance(item) < 0 &&
         availableWithdrawAmount <= setOffSelectors.getSetOffTotalOutstandingBalance(item)
       ) {
         availableWithdrawAmount += Math.abs(setOffSelectors.getSetOffTotalOutstandingBalance(item));
         return {
           negative: true,
           total: Math.abs(setOffSelectors.getSetOffTotalOutstandingBalance(item)),
         };
       } else if (
         availableWithdrawAmount < 0 &&
         setOffSelectors.getSetOffTotalOutstandingBalance(item) < 0 &&
         availableWithdrawAmount > setOffSelectors.getSetOffTotalOutstandingBalance(item)
       ) {
         const remainingAmount = Math.abs(availableWithdrawAmount);
         availableWithdrawAmount += remainingAmount;
         return {
           negative: true,
           total: Math.abs(remainingAmount).toFixed(2),
         };
       }

       return {
         negative: true,
         total: 0,
       };
     });
     setPartAmt(autoOffsetData);
   } else if (creditValue > debitValue) {
     let trustTotal = 0
     _.forEach(setOffData, (i,index)=> {
       const amount = Number(_.get(partAmt,[index,'total'],0))

       trustTotal +=  setOffSelectors.getSetOffTotalOutstandingBalance(i) < 0 ?  setOffSelectors.getSetOffTotalOutstandingBalance(i) + amount : 0;
     });
    // let outstandingTotal = 0
    //
    //
    //  _.forEach(setOffData, function(i,index) {
    //    const amount = Number(_.get(partAmt,[index,'total'],0))
    //    outstandingTotal += setOffSelectors.getSetOffTotalOutstandingBalance(i) > 0 ? setOffSelectors.getSetOffTotalOutstandingBalance(i) - amount : 0;
    //  });

     const amountToBalance = creditValue - debitValue
     if((trustTotal * -1) < (amountToBalance)){
      NotificationMessage.error("No enough balance to setoff current amount")
        return
     }
     let tempBalance = amountToBalance
    const autoSetoffData =  _.flatMap(setOffData,(i,index)=> {
      const amount = Number(_.get(partAmt,[index,'total'],0))
      const balance= setOffSelectors.getSetOffTotalOutstandingBalance(i)
      if(balance < 0) {
        const usedBalance = (balance*-1) - amount
        if (tempBalance == 0) {
          return {
            ...partAmt[index]
          }
        }

        if (usedBalance > tempBalance) {
          const totalAmount =amount + tempBalance

          tempBalance=0

          return {
            negative: true,
            total: Math.abs(totalAmount)
          }
        } else {


          tempBalance = _.ceil(tempBalance - usedBalance,2)

          return {
            negative: true,
            total: Math.abs(balance),
          }
        }
        return {
          ...partAmt[index]
        }
      }else {
        return {
          ...partAmt[index]
        }
      }
    })
     setPartAmt(autoSetoffData);

   } else if (creditValue < debitValue) {

     let outstandingTotal = 0


      _.forEach(setOffData, function(i,index) {
        const amount = Number(_.get(partAmt,[index,'total'],0))
        outstandingTotal += setOffSelectors.getSetOffTotalOutstandingBalance(i) > 0 ? setOffSelectors.getSetOffTotalOutstandingBalance(i) - amount : 0;
      });

     const amountToBalance = debitValue - creditValue
     if((outstandingTotal) < (amountToBalance)){
       NotificationMessage.error("No enough balance to setoff current amount")
       return
     }
     let tempBalance = amountToBalance
     const autoSetoffData =  _.flatMap(setOffData,(i,index)=> {
       const amount = Number(_.get(partAmt,[index,'total'],0))
       const balance= setOffSelectors.getSetOffTotalOutstandingBalance(i)
       if(balance > 0) {
         const usedBalance = (balance) - amount
         if (tempBalance == 0) {
           return {
             ...partAmt[index]
           }
         }
         if (usedBalance > tempBalance) {
           let totalAmount = amount + tempBalance
           tempBalance=0
           return {
             negative: false,
             total: totalAmount
           }
         } else {

           tempBalance = tempBalance - usedBalance
           return {
             negative: false,
             total: balance,
           }
         }
         return {
           ...partAmt[index]
         }
       }else {
         return {
           ...partAmt[index]
         }
       }
     })
     setPartAmt(autoSetoffData);

   }
  };


  const getDebitAmount = (partAmtData) => {
    const debit = _.map(partAmtData, (item, index) => {
      if (item.negative) {
        return _.floor(item.total, 2);
      }
    });
    return _.isNaN(_.sum(debit)) || _.isUndefined(_.sum(debit)) ? 0 : _.sum(debit);
  };

  const getCreditAmount = (partAmtData) => {
    const credit = _.map(partAmtData, (item, index) => {
      if (!item.negative) {
        return _.floor(item.total, 2);
      }
    });
    return _.isNaN(_.compact(credit)) || _.isUndefined(_.compact(credit)) ? 0 : _.sum(_.compact(credit));
  };

  const debitValue = getDebitAmount(partAmt);
  const creditValue = getCreditAmount(partAmt);

  const checkValid = debitValue !== 0 && creditValue !== 0;

  const isAutoSetOffEnabled = () => {
    if(_.isEmpty(partAmt)){
      return true
    }
   if(creditValue === debitValue){
     return false
   }
    return true
  }
  return (
      <Container fluid>
        <div className={"primary-border-table-border"}>
          <div className={clsx("custom-card-label-container")}>
            <div className={clsx("d-flex")}>
              <div><h2>{selectedCurrency?.text}</h2>
              </div>
              <div className={clsx('d-flex justify-content-center flex-fill')}><h2>Setoff</h2>
              </div>

            </div>
          </div>
          <div className="custom-table-info-container padding-12px pt-2">
            <Row>
              <Col
                  sm={12}
                  md={6}
                  lg={6}
                  className="d-flex align-items-center justify-content-center justify-content-md-start"
              ></Col>
              <Col sm={12} md={6} lg={6}>
                <div
                    className="d-flex flex-column my-2 align-items-end justify-content-end custom-button-setoff-auto-set-up justify-content-center justify-content-md-end">
                  <p className="mb-1">You are allowed to select Auto Setoff</p>
                  <button
                      onClick={onClickAutoSetUp}
                      className={clsx("btn custom-button-auto-set-up")}
                      type="submit"
                      disabled={!isAutoSetOffEnabled()}
                  >
                    Auto Setoff
                    <FontAwesomeIcon
                        icon={faCircleInfo}
                        style={{marginLeft: "10px"}}
                    />
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          <div className={clsx("custom-table-info-container padding-12px")}>
            <CustomSetOffTable
                partAmt={partAmt}
                setPartAmt={setPartAmt}
                data={setOffData}
                creditValue={creditValue}
                debitValue={debitValue}
                selectedCurrency={selectedCurrency}
            ></CustomSetOffTable>
            <div className="d-flex justify-content-center py-3">
              <button
                  onClick={() => history.goBack()}
                  className={clsx("btn custom-button-back")}
                  type="submit"
              >
                Back
              </button>
              <button
                  className={clsx("btn custom-button-primary", {
                    ["disabled"]: !_.isEqual(
                        Helper.formattedPrice(debitValue),
                        Helper.formattedPrice(creditValue),
                    ),
                  })}
                  disabled={
                    !_.isEqual(
                        Helper.formattedPrice(debitValue),
                        Helper.formattedPrice(creditValue),
                    ) || !checkValid
                  }
                  type="submit"
                  style={{backgroundColor: "#9D7905"}}
                  onClick={() => {
                    setShow(true);
                    setType(constants.SET_OFF_TYPE);
                  }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <SetoffDisclaimerNote></SetoffDisclaimerNote>

        <ConfirmationSetOffModal
            show={show}
            data={data}
            partAmt={partAmt}
            handleSubmit={handleSubmit}
            handleClose={() => setShow(false)}
            loading={isLoading}
            type={type}
            selectedCurrency={selectedCurrency}
        ></ConfirmationSetOffModal>
      </Container>
  );
}

export default SetOff;
